<div class="flex gap-2 relative">
    <button pButton class="p-button-outlined" pTooltip="Patient Actions" label="Actions"
        (click)="toggleActionsMenu($event)">
        <i class="material-icons">bolt</i>
    </button>
    <p-menu #menu [popup]="true" [model]="[]" [appendTo]="'body'"></p-menu>
</div>

<p-dialog header="Add Treatment" [(visible)]="showTreatmentDialog" [modal]="true" [style]="{width: '35vw'}"
    [draggable]="false" [resizable]="false" [closable]="true" appendTo="body" (onHide)="showTreatmentDialog=false">

    <app-crud-treatment *ngIf="showTreatmentDialog" [orgId]="orgId" [patientId]="patientId"
        (onFormSubmit)="onTreatmentSubmit()" crudMode="create">
    </app-crud-treatment>

</p-dialog>